const tokenName = 'token'

export default {
  tokenName
}